import React from 'react';

export default function usePrevious(value) {
  const [current, setCurrent] = React.useState(value);
  const [previous, setPrevious] = React.useState(null);

  if (value !== current) {
    setPrevious(current);
    setCurrent(value);
  }

  return previous;
}



// WEBPACK FOOTER //
// ./hooks/usePrevious.js